import styled from "styled-components";

const SelectWrapStyled = styled.div<{ left: number | undefined }>`
  position: relative;

  & .prefix-icon-wrapper {
    display: flex;
    position: absolute;
    z-index: 1;
    padding: 5px 0 5px 11px;
    width: fit-content;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .ant-select {
    &:not(.ant-select-focused).has-values {
      // 값있을 때 스타일처리

      & .ant-select-selector {
        box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
        border-color: #0d0c0c;
      }
      & .ant-select-clear {
        opacity: 1;
      }
    }

    &.multiple {
      // 태그아닌 멀티
      &
        .ant-select-selection-overflow-item:not(.ant-select-selection-overflow-item-rest, .ant-select-selection-overflow-item-suffix) {
        &:after {
          content: ",";
        }
      }
    }

    & .ant-select-selector {
      padding-left: ${({ left }) => left || 11}px;
      transition: none;
      height: inherit !important;

      & .ant-select-selection-search {
        padding-left: calc(${({ left }) => left}px - 11px);
        & > input {
          height: 100%;
        }
      }
      & .ant-select-selection-placeholder,
      & .ant-select-selection-item {
        line-height: 32px;
      }
      & .ant-select-selection-overflow {
        & .ant-select-selection-search {
          padding-left: 0;
          margin: 0;
        }
      }
    }
    &.ant-select-multiple .ant-select-selection-placeholder {
      padding-left: calc(${({ left }) => left}px - 11px);
    }
  }
`;

export { SelectWrapStyled };
